import qs from 'querystring';

function req(url, method = 'get') {
	const xhr = new XMLHttpRequest();
	xhr.open(method.toUpperCase(), url, true);
	xhr.send();
	return xhr;
}

class CartActions {

	addItem(productId, modelId = null) {
		this.dispatch({productId, modelId});
		req(`basket/put?${qs.stringify({productId: productId, modelId: modelId})}`);
	}

	removeItem(productId, modelId = null) {
		this.dispatch({productId, modelId});
		req(`basket/deleteById?${qs.stringify({productId: productId, modelId: modelId})}`);
	}

}

export default CartActions;


/** WEBPACK FOOTER **
 ** ./src/scripts/actions/CartActions.js
 **/